<div class="flex-column ui-helper-content-wrapper">
  <div class="flex-row space-between align-center">
    <div class="mat-h3" style="margin: unset">Hilfe</div>
    <mat-icon (click)="closeOverlay()" [svgIcon]="EsvgFiles.close"></mat-icon>
  </div>
  <mat-divider/>
  <div class="help-content" #helpContentHost>

  </div>
</div>

